<template>
  <div class="SaleItemCardContainer">
    <nut-row class="pd16 brd4 box bothCenter colFlex boldFont"
             style="box-shadow: 0px 0px 12px 0px rgba(127,127,127,0.26);">
      <nut-row class="leftCenter">
<!--        <nut-col :span="5">-->
<!--          <span class="ft18" style="font-style: italic;">NO.{{ data.id }}</span>-->
<!--        </nut-col>-->
        <nut-col :span="24" class="leftCenter ft20 ">
          <nut-ellipsis :rows="1" :content="data.name"></nut-ellipsis>
<!--          <span>{{ data.name }}</span>-->
        </nut-col>
      </nut-row>

      <nut-row class="bothCenter">
        <nut-col :span="12" class="leftCenter boldFont">
          <span class="numberText">¥</span>
          <span class="numberText ft36 ml2">{{ minSkuPrice }}</span>
          <span class="numberText ft12 ml4" v-if="data.skus.length > 1">起</span>
        </nut-col>
        <nut-col :span="12" class="rightCenter">
          <div class="bothCenter brd8 opd8 vpd2" style="border: 1px solid #EF783C;">
            <img src="https://cdn.waityou.online/00eef64f-e097-fc90-7f19-3f1ed5ab471b.png"
                 style="width: 18px">
            <span class="numberText ft16 ml4">分享</span>
          </div>
        </nut-col>
      </nut-row>
<!--      <nut-row class="bothCenter">-->
<!--        <template v-for="(img,imgIndex) in data.images" :key="img">-->
<!--          <nut-col :span="8" class="leftCenter" v-if="imgIndex < 3">-->
<!--            <img :src="`${img}?x-oss-process=image/resize,p_10`" style="width: 26vw;height:26vw;object-fit: cover" class="brd6"/>-->
<!--          </nut-col>-->
<!--        </template>-->
<!--      </nut-row>-->
      <nut-row class="mt8" v-if="data.bannerImage">
        <img :src="data.bannerImage" class="wd100 brd6">
      </nut-row>
<!--      <nut-row style="background: #F4F4F4" class="brd4 mt12 vpd4 opd8 box leftCenter">-->
<!--        <AvatarRow :avatars="data.buyerAvatars"/>-->
<!--        <span class="numberText ml8 ft14">{{-->
<!--            data.fakeBuyerCnt + data.realBuyerCnt-->
<!--          }}人跟团中｜{{ data.fakeBuyerCnt + data.realViewCnt }}人看过</span>-->
<!--      </nut-row>-->
    </nut-row>
  </div>
</template>

<script>

export default {
  name: "SaleItemCard",
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    minSkuPrice() {
      let m = 999999999;
      for (let s of this.data.skus) {
        if (s.price < m) {
          m = s.price;
        }
      }
      return (m / 100).toFixed(0)
    }
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleItemCardContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 12px 0;
}
</style>